import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import productService from "../Services/productService";
import * as xlsx from "xlsx";
import toast from "react-hot-toast";
import { FaArrowRightLong, FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import { RiDiscountPercentLine, RiFileExcel2Line } from "react-icons/ri";
import orderService from "../Services/orderService";
import Loading from "../Components/Loading";
import customerService from "../Services/customerService";
import priceListService from "../Services/priceListService";
import moment from "moment";
import Dropdown from "../Components/Dropdown";
import DatePicker from "../Components/DatePicker";
import SecondaryButton from "../Components/SecondaryButton";
import { MdClose } from "react-icons/md";
import { BsExclamation } from "react-icons/bs";
import { HiOutlineTrash } from "react-icons/hi";
import { IoDocumentTextOutline } from "react-icons/io5";

const AddOrder = () => {
  const [tab, setTab] = React.useState("Part Number");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [customers, setCustomers] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [products, setProducts] = useState([]);
  const [file, setFile] = useState(null);
  const [partNumber, setPartNumber] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [priceCheck, setPriceCheck] = useState(false);
  const [deliveryCheck, setDeliveryCheck] = useState(false);
  // const customerProfile = JSON.parse(localStorage.getItem("customer"));
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [orderDate, setOrderDate] = useState("");
  const [discount, setDiscount] = useState(false);
  const [discountList, setDiscountList] = useState([]);
  const [reference, setReference] = useState("");
  const [customerDropdown, setCustomerDropdown] = useState(false);

  const [orderData, setOrderData] = useState({
    customer: "",
    name: "",
    email: "",
    phone: "",
    amount: 0,
  });

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const getCustomers = async () => {
      await customerService.fetchAll().then((res) => {
        setCustomers(res.customers);
      });
    };
    getCustomers();
  }, []);

  // useEffect(() => {
  //     if (selectedCustomer) {
  //         setOrderData((data) => ({
  //             ...data,
  //             customer: selectedCustomer.id,
  //             name: selectedCustomer.first_name + " " + selectedCustomer.last_name,
  //             email: selectedCustomer.email,
  //             phone: selectedCustomer.phone,
  //         }));
  //     }
  // }, [selectedCustomer]);

  useEffect(() => {
    if (products.length !== 0) {
      const getProducts = async () => {
        try {
          setInitialData([]);
          setLoading(true);
          let parts = [];
          let quantities = {};
          console.log(products);
          products.map((single) => {
            let partNumber = single["Part Number"].toString();
            parts.push(partNumber.replace("-", ""));
            console.log(single);
            quantities[partNumber.replace("-", "")] = single.QTY;
          });
          let response;
          if (discount) {
            response = await productService.searchByVendorCustomerAndDate(
              parts.toString(),
              moment(orderDate).format("YYYY-MM-DD"),
              selectedCustomer.id,
            );
          } else {
            response = await productService.searchByPart(parts.toString());
          }
          setInitialData((d) => [
            ...d,
            ...response.products.map((item) => ({
              ...item,
              qty:
                quantities[item.vendor_code] > item.quantity
                  ? item.quantity
                  : quantities[item.vendor_code],
              limited: quantities[item.vendor_code] > item.quantity,
              empty: item.quantity === 0,
              show: true,
            })),
          ]);
          setLoading(false);
          setProducts([]);
        } catch (e) {}
      };
      getProducts();
    }
  }, [products]);

  useEffect(() => {
    const checkDiscountForCustomer = async () => {
      try {
        const response = await priceListService.priceListByCustomer(
          selectedCustomer.id,
        );
        setDiscountList(response?.priceList);
        setOrderDate(response.priceList[0]?.date);
      } catch (e) {
        console.error("Failed to fetch List", e);
      }
    };
    checkDiscountForCustomer();
  }, [selectedCustomer]);

  useEffect(() => {
    setData(
      initialData.reduce((acc, current) => {
        const isDuplicate = acc.some(
          (item) =>
            item.id === current.id && item.supplier === current.supplier,
        );
        if (!isDuplicate) {
          acc.push(current);
        }
        return acc;
      }, []),
    );
  }, [initialData]);

  useEffect(() => {
    if (data.length !== 0) {
      setShowTable(true);
    }
  }, [data]);

  const handleFileSelect = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        setFile(data);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const ProceedFileRead = () => {
    if (file) {
      const workbook = xlsx.read(file, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = xlsx.utils.sheet_to_json(worksheet);
      setProducts(json);
    } else {
      toast.error("Please upload any file!");
    }
  };

  const handleChange = (v) => {
    setTab(v);
  };

  const handleInput = (value, tab) => {
    if (tab === "Part Number") {
      setPartNumber(value);
    }
  };

  const handleSearch = (tab) => {
    if (tab === "Part Number") {
      if (partNumber) {
        setProducts((p) => [...p, { "Part Number": partNumber, QTY: 1 }]);
      }
    }
  };

  const totalQuantity = data.reduce(
    (acc, item) => (item.show ? acc + item.qty : acc),
    0,
  );
  const totalWeight = data.reduce(
    (acc, item) => (item.show ? acc + parseFloat(item.weight || 0) : acc),
    0,
  );
  const totalPrice = data.reduce(
    (acc, item) => (item.show ? acc + item.qty * parseFloat(item.price) : acc),
    0,
  );

  const proceedToCheckout = () => {
    let submit = { ...orderData };
    const transformedProducts = data.map((item) => ({
      brand: item.brand,
      created_at: item.created_at,
      delivery: item.delivery,
      product: item.id,
      price: item.price,
      quantity: item.qty,
      show: item.show,
      supplier_code: item.supplier_code,
      supplier: item.supplier,
      title: item.title,
      vendor_code: item.vendor_code,
      weight: item.weight,
    }));

    submit.amount = totalPrice;
    submit.order_date = date;
    submit.email = selectedCustomer?.email;
    submit.phone = selectedCustomer?.phone_number;
    submit.customer = selectedCustomer?.id;
    submit.reference = reference;
    submit.recipient =
      selectedCustomer?.first_name + selectedCustomer?.last_name;
    submit.products = transformedProducts.filter((value) => value.show);
    orderService.submitOrder(submit).then((response) => {
      if (response.responseCode === 200) {
        navigate("/order");
      }
    });
  };

  const handleIncrement = (v, id) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id && item.quantity >= v && v > 0
          ? { ...item, qty: v }
          : item,
      ),
    );
  };

  const handleDecrement = (v, id) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id && item.quantity >= v && v > 0
          ? { ...item, qty: v }
          : item,
      ),
    );
  };

  const initialDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  const downloadQuotation = () => {
    const summary = [
      { Weight: "Total Quantity", Delivery: totalQuantity },
      { Weight: "Total Weight", Delivery: totalWeight },
      { Weight: "Total Price", Delivery: totalPrice.toFixed(2) },
    ];

    const transformedData = data.map((item) => ({
      "Vendor Code": item.vendor_code,
      Brand: item.brand,
      Title: item.title,
      "Ordered Quantity": item.qty,
      Price: item.price,
      Weight: item.weight,
      Delivery: item.delivery,
    }));

    const blankRows = [{}, {}, {}];
    const fullData = [...transformedData, ...blankRows, ...summary];

    const worksheet = xlsx.utils.json_to_sheet(fullData);

    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Quotation");

    const excelBuffer = xlsx.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "quotation.xlsx");
    document.body.appendChild(link);
    link.click();

    link.parentNode.removeChild(link);
  };

  const handleCheckBoxChange = (v, n) => {
    if (n === "min-price") {
      setPriceCheck(v);
      setDeliveryCheck(false);
      if (v) {
        const vendors = {};
        let tData = [...data].sort((a, b) => a.price - b.price);
        tData.map((item) => {
          const { vendor_code, price } = item;
          if (vendors[vendor_code]) {
            if (price < vendors[vendor_code].price) {
              vendors[vendor_code].show = false;
              item.show = true;
            } else {
              item.show = false;
            }
          } else {
            vendors[vendor_code] = item;
            item.show = true;
          }
        });
        setData(tData);
      } else {
        setData(
          data.map((product) => ({
            ...product,
            show: true,
          })),
        );
      }
    } else if (n === "delivery-days") {
      setPriceCheck(false);
      setDeliveryCheck(v);
      if (v) {
        const vendors = {};
        let tData = [...data].sort((a, b) => a.delivery - b.delivery);
        tData.map((item) => {
          const { vendor_code, delivery } = item;
          if (vendors[vendor_code]) {
            if (delivery < vendors[vendor_code].delivery) {
              vendors[vendor_code].show = false;
              item.show = true;
            } else {
              item.show = false;
            }
          } else {
            vendors[vendor_code] = item;
            item.show = true;
          }
        });
        setData(tData);
      } else {
        setData(
          data.map((product) => ({
            ...product,
            show: true,
          })),
        );
      }
    }
  };

  const handleCustomerSelect = (customerOrId) => {
    const customer =
      typeof customerOrId === "object"
        ? customerOrId
        : customers.find((c) => parseInt(c.id) === parseInt(customerOrId));

    setSelectedCustomer(customer);
    setCustomerDropdown(false);
  };

  const handleDateChange = (option) => {
    console.log("Selected option:", option);
    setOrderDate(option || ""); // fallback if somehow null
  };

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg min-h-[calc(100vh-48px)] bg-white">
      <h1 className="font-bold text-center text-3xl text-secondary mt-10">
        Add New Order
      </h1>
      <div className="px-80 mt-10">
        <div className="grid grid-cols-5 gap-4 mt-10">
          <div className="col-span-1">
            <input
              type="text"
              name="from"
              placeholder="Enter Reference No."
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              className="primary-input"
            />
          </div>
          <div className="col-span-1">
            <DatePicker
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
          <Dropdown
            styling="!col-span-3"
            selected={selectedCustomer?.id}
            placeholder="Select Customer"
            onChange={handleCustomerSelect}
            options={customers.map((c) => ({
              label: `${c.first_name} ${c.last_name} - ${c.email}`,
              value: c.id,
            }))}
          />
        </div>
        {orderDate !== null && (
          <div className="flex justify-center items-center min-h-16 w-full">
            {discount === true && orderDate ? (
              <div className="flex flex-col justify-center items-center gap-4 mt-4">
                <div className="text-cyan-600 text-xs font-semibold px-8 py-2 border shadow-sm rounded-lg">
                  Special Price Applied
                </div>
                <SecondaryButton
                  text="Clear Changes"
                  Icon={MdClose}
                  onClick={() => setDiscount(false)}
                  color="text-red-600"
                />
              </div>
            ) : (
              <div className="flex flex-row items-center justify-between w-full mt-4">
                <div>
                  {discountList?.length > 0 && (
                    <Dropdown
                      styling="w-[200px]"
                      selected={orderDate} // Ensure this matches discount.date format
                      placeholder="Select Date"
                      onChange={handleDateChange || "date is selected"}
                      options={discountList?.map((discount) => ({
                        label: moment(discount.date).format("DD-MM-YYYY"),
                        value: discount.date, // Use original value (no conversion)
                      }))}
                    />
                  )}
                </div>
                <SecondaryButton
                  text="Apply Special Discount"
                  Icon={RiDiscountPercentLine}
                  onClick={() => setDiscount(true)}
                  color="!bg-cyan-600 text-white"
                />
              </div>
            )}
          </div>
        )}
        {selectedCustomer ? (
          <div className=" flex justify-center mt-10 w-full">
            <div className="flex flex-row w-[80%] justify-end py-2 rounded-3xl">
              <input
                onChange={(e) => handleFileSelect(e)}
                type="file"
                className="primary-input !rounded-r-none
                                file:mr-4 file:py-[2px] file:px-3 file:rounded-md file:duration-300
                                file:border-0 file:text-sm file:font-medium
                              file:bg-white file:text-black
                              hover:file:bg-primary hover:file:text-white"
              />
              <button
                onClick={() => ProceedFileRead()}
                className="bg-primary px-4 w-40 py-1 rounded-r-[0.5rem] text-white font-medium text-sm"
              >
                Proceed
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {loading ? (
        <div className="flex items-center justify-center py-8">
          <Loading />
        </div>
      ) : (
        <>
          {showTable && (
            <div className="flex flex-col w-full gap-2 mt-5">
              <div>
                <p className="text-cyan-600 font-semibold px-4 py-2 border shadow-sm rounded-lg w-fit">
                  {data.length} Products Found
                </p>
              </div>
              <div className="table-div">
                <table className="w-full">
                  <thead>
                    <tr className="border-y-2 text-center w-full text-black text-[10px]">
                      <th className="w-[8%] py-4">Qty</th>
                      <th className="text-left w-[8%]">Brand</th>
                      <th className="text-left w-[8%]">Part No.</th>

                      <th className="text-left w-[14%]">Title</th>
                      <th className="w-[8%]">Stock</th>
                      <th className="w-[8%]">Weight (Kg)</th>
                      <th className="w-[8%]">Total Weight</th>
                      <th className="w-[8%]">Delivery</th>
                      <th className="w-[8%]">Price</th>
                      <th className="w-[8%]">Total Price</th>
                      <th className="w-[8%]">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((data, index) => (
                      <tr
                        key={index}
                        className={`border-b border-gray-200 text-center ${data.show ? "" : "hidden"}`}
                      >
                        <td className="py-4 text-center text-[12px] w-[8%]">
                          <div className="flex rounded-md justify-center items-center ">
                            <div className="flex flex-row items-center gap-1">
                              <div>
                                <FaMinus
                                  className="cursor-pointer p-1 h-5 w-5 bg-red-500 rounded-md text-white"
                                  onClick={() =>
                                    handleDecrement(data.qty - 1, data.id)
                                  }
                                />
                              </div>
                              <p
                                className={`w-[20px] text-center font-extrabold rounded-md`}
                              >
                                {data.qty}
                              </p>
                              <div>
                                <FaPlus
                                  className="cursor-pointer p-1 h-5 w-5 bg-green-500 rounded-md text-white"
                                  onClick={() =>
                                    handleIncrement(data.qty + 1, data.id)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className=" py-4 text-left font-bold text-[12px] w-[8%]">
                          {data.brand}
                        </td>
                        <td className=" py-4  text-left text-[12px] w-[8%]">
                          {data.vendor_code}
                        </td>

                        <td className="py-4 text-left text-[12px] w-[14%]">
                          {data.title}
                        </td>
                        <td className="py-4 text-left text-[12px] w-[8%]">
                          <div className="flex flex-row gap-2 items-center justify-center">
                            {data.empty ? (
                              <BsExclamation className="bg-red-600 text-lg text-white px-px py-px rounded-full" />
                            ) : data.limited ? (
                              <BsExclamation className="bg-amber-600 text-lg text-white px-px py-px rounded-full" />
                            ) : (
                              ""
                            )}
                            {data.quantity}
                          </div>
                        </td>
                        <td className="py-4 text-[12px] w-[8%]">
                          {data.weight}
                        </td>
                        <td className="py-4 text-[12px] w-[8%]">
                          {parseFloat(data.quantity * data.weight).toFixed(2)}
                        </td>
                        <td className="py-4 text-[12px] w-[8%]">
                          {data.delivery}
                        </td>
                        <td className="py-4 text-[12px] w-[8%]">
                          <input
                            className={`w-16 text-center border-gray-500 py-2 bg-gray-100 rounded-lg`}
                            value={data.price.toFixed(2)}
                          />
                        </td>
                        <td className="py-4 font-bold text-[12px] w-[8%]">
                          {parseFloat(data.price * data.qty).toFixed(2)}
                        </td>
                        <td className="py-4 text-[12px] w-[8%]">
                          <div className="flex flex-row justify-center gap-4">
                            <div onClick={() => initialDelete(data.id)}>
                              <HiOutlineTrash className="h-4 w-4 text-red-500" />
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="flex flex-row justify-center gap-4 mt-10 flex-wrap">
                {[
                  {
                    label: "Total Price",
                    value: `${parseFloat(totalPrice).toFixed(2)} AED`,
                  },
                  {
                    label: "Total Weight",
                    value: `${parseFloat(totalWeight).toFixed(2)} KG`,
                  },
                  {
                    label: "Total Quantity",
                    value: `${parseFloat(totalQuantity).toFixed(0)} AED`,
                  },
                ].map((stat) => (
                  <div
                    key={stat.label}
                    className="flex flex-col bg-gray-50 border border-gray-200 rounded-xl px-5 py-3"
                  >
                    <span className="text-[10px] text-gray-400 uppercase tracking-wide font-semibold">
                      {stat.label}
                    </span>
                    <span className="text-sm font-bold text-gray-800 mt-1">
                      {stat.value}
                    </span>
                  </div>
                ))}
              </div>

              <div className="flex justify-center mt-10">
                <SecondaryButton
                  text="Generate Order"
                  Icon={IoDocumentTextOutline}
                  color="!bg-cyan-600 text-white"
                  onClick={() => proceedToCheckout()}
                />
              </div>
            </div>
          )}{" "}
        </>
      )}
    </main>
  );
};

export default AddOrder;
